import React from 'react';
import { Typography } from '@mui/material';

/**
 * Account number template with monospace font
 */
export const AccountTemplate: React.FC<{ accountNumber?: string }> = ({ accountNumber }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
    {accountNumber || '-'}
  </Typography>
);

export default AccountTemplate;
